import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export interface DateTimeFieldModel extends BaseFieldModel {
  defaultValue: string | undefined;
  placeholder: CultureTextModel[] | string;
  type: FieldType.Datetime;
}

export class DateTimeField extends BaseField implements DateTimeFieldModel {
  public defaultValue: string | undefined;
  public placeholder: CultureTextModel[] | string = '';
  public type: FieldType.Datetime = FieldType.Datetime;

  constructor(cultures: string[]) {
    super(FieldType.Datetime, cultures);

    this.placeholder = [];
    for (const culture of cultures) {
      this.placeholder.push({ culture, value: '' });
    }
  }
}
